<div>
  @switch (type) {
    @case ('CARD') {
      <div
        class="ea-placeholder placeholder-card animated infinite flash slower d-flex"
      >
        <div class="placeholder-profil-pic mbm rounded"></div>
        <div class="placeholder-title mid greyed mbm"></div>
        <div class="placeholder-text mid"></div>
        <div class="placeholder-text long"></div>
        <div class="placeholder-text small"></div>
        <div class="divider long"></div>
        <div class="row long mbs">
          <div class="col-xs-5">
            <div class="placeholder-text greyed"></div>
          </div>
          <div class="col-xs-2">
            <div class="placeholder-text greyed"></div>
          </div>
          <div class="col-xs-5">
            <div class="placeholder-text greyed"></div>
          </div>
        </div>
        <div class="placeholder-text greyed small"></div>
      </div>
    }
    @case ('LINE') {
      <div
        class="ea-placeholder placeholder-line animated infinite flash slower d-flex"
      >
        <div>
          <div class="placeholder-icon rounded"></div>
          <div class="placeholder-text long man"></div>
        </div>
        <div class="placeholder-button"></div>
      </div>
    }
    @case ('TABLE') {
      <div
        class="ea-placeholder placeholder-table animated infinite flash slower d-flex"
      >
        <div class="full-w mbl">
          <div class="placeholder-pin rounded"></div>
          <div class="placeholder-title greyed small"></div>
        </div>
        <div>
          <div class="placeholder-text mid greyed"></div>
          <div class="placeholder-text mid greyed"></div>
          <div class="placeholder-text mid greyed"></div>
          <div class="placeholder-text mid greyed"></div>
          <div class="placeholder-text mid greyed"></div>
        </div>
        <div class="divider"></div>
        <div class="mbl">
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
        </div>
        <div class="mbl">
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
        </div>
        <div class="mbl">
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
        </div>
        <div class="mbl">
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
          <div class="placeholder-text mid"></div>
        </div>
      </div>
    }
  }
</div>
